import React, { useContext, useEffect, useState } from "react"
import { UsuarioContext } from "../Context/Usuario"
import { Nav, Navbar, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import UAI from "../UAI"
import "./UAINavbar.css"

const UAISideBar = (props) => {
  const { usuario } = useContext(UsuarioContext)
  const [categories, setCategories] = useState([])

  useEffect(() => {
    let sorted = UAI.obtieneVistasCategorias(usuario)
    setCategories(sorted)
  }, [])

  return (<>
  
    <Navbar bg="dark" variant="dark" className="noprint">
      <Navbar.Collapse>
        <Nav className="flex-column">
          {usuario &&
            !usuario.error &&
            categories.map((category) => (
              <NavDropdown
                key={category.title}
                className={"icono-mp tour-" + category.title}
                title={<>
                    {category.icon} {props.expand ? category.title +"    " : ""}
                  </>
                }
              >
                {category.views.map((view) => {
                  if (view.divider) {
                    return <NavDropdown.Divider key={view.key} />
                  } else if (view.header) {
                    return (
                      <NavDropdown.Header key={view.key}>
                        {view.title}
                      </NavDropdown.Header>
                    )
                  } else {
                    return (
                      <LinkContainer
                        key={view.key}
                        to={
                          (view.external ? "" : "/cohortes") +
                          "/" +
                          view.key +
                          (view.external ? "" : "/todas")
                        }
                      >
                        <NavDropdown.Item>{view.title}</NavDropdown.Item>
                      </LinkContainer>
                    )
                  }
                })}
              </NavDropdown>
            ))}
        </Nav>
      </Navbar.Collapse>
    </Navbar></>
  )
}

export default UAISideBar
